// F-V / F-W: the lists' narration badges link to an edit form with
// `#narration`. Once the record has loaded, scroll its media panel
// (Narration is the panel's default tab) into view — once per visit.

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function useNarrationAnchor(
  ownerKey: "exhibit" | "zone",
  loaded: boolean,
): void {
  const { hash } = useLocation();
  const done = useRef(false);
  useEffect(() => {
    if (hash !== "#narration" || !loaded || done.current) return;
    done.current = true;
    document
      .querySelector(`[data-testid="media-panel-${ownerKey}"]`)
      ?.scrollIntoView({ block: "start" });
  }, [hash, loaded, ownerKey]);
}
